export { default as dividersSet } from './dividersSet';


// WEBPACK FOOTER //
// ./src/containers/elements/Dividers/constants/index.js